module.exports = __webpack_public_path__ + "static/img/PFK_OurStory_Photo1_800x290.945f490.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_OurStory_Photo1_800x290.jpg
// module id = 322
// module chunks = 2